export default {
  logo: require('./logo.png'),
  logo2: require('./logo_2.svg'),
  jetty: require('./jetty.svg'),
  check: require('./check.svg'),
  upload: require('./upload.svg'),
  download: require('./download.svg'),
  success: require('./done.svg'),
  remove: require('./remove.svg'),
  BoatRed: require('./boat.svg'),
  plus: require('./plusIcon.svg'),
  iconJetty: require('./jetty.svg'),
  posponed: require('./postponed.png'),
  confirm: require('./Group-6167.svg'),
  reject: require('./Group-4582.svg'),
  approve: require('./Group-4550.svg'),
  doneBlue: require('./done-blue.svg'),
  SortIcon: require('./SortIcon.svg'),
  portIcon: require('./icon-port.svg'),
  jettyLogo: require('./jettyLogo.svg'),
  reviseRed: require('./Revise-red.svg'),
  reviseLogo: require('./Group-4995.svg'),
  vesselImage: require('./vessel-image.svg'),
  vesselIconBlack: require('./icon-vessel-black.svg'),
  vesselIconRed: require('./icon-vessel-red.svg'),
  vesselIconBlue: require('./icon-vessel-blue.svg'),
  vesselIconYellow: require('./icon-vessel-yellow.svg'),
  vesselIconYellowPulse: require('./icon-vessel-yellow-pulse.svg'),
  vesselIconBluePulse: require('./icon-vessel-blue-pulse.svg'),
  vesselIconGreen: require('./icon-vessel-green.svg'),
  vesselIconPurple: require('./icon-vessel-purple.svg'),
  vesselIconBlackPulse: require('./icon-vessel-black-pulse.svg'),
  vesselIconRedPulse: require('./icon-vessel-red-pulse.svg'),
  vesselIconGreenPulse: require('./icon-vessel-green-pulse.svg'),
  navbarModal: require('./HeaderModal.svg'),
  pointHereIcon: require('./ellipse-11.svg'),
  logoModal: require('./HeaderLogoModal.svg'),
  inboundbtn: require('./Inbound-btn.svg'),
  deleteIcon: require('./baseline-delete-24px.svg'),
  sortDirIcon: require('./sort-dir-icon.svg'),
  xIcon: require('./x-icon.svg'),
  currentLocationIcon: require('./currentLocation.svg'),
  filesIconDoc: require('./files icon-DOCX.svg'),
  filesIconXls: require('./files icon-XLS.svg'),
  filesIconPdf: require('./files icon-PDF.svg'),
  filesIconImg: require('./files icon-IMG.svg'),
  filesIconPst: require('./files-icon-PST.svg'),
  DraftGreen: require('./DraftGreen.svg'),
  DraftRed: require('./DraftRed.svg'),
  DraftGrey: require('./DraftGrey.svg'),
  WaitAppGreen: require('./WaitAppGreen.svg'),
  WaitAppRed: require('./WaitAppRed.svg'),
  WaitAppGrey: require('./WaitAppGrey.svg'),
  AppRejGreen: require('./AppRejGreen.svg'),
  AppRejRed: require('./AppRejRed.svg'),
  AppRejGrey: require('./AppRejGrey.svg'),
  ProgGreen: require('./ProgGreen.svg'),
  ProgRed: require('./ProgRed.svg'),
  ProgGrey: require('./ProgGrey.svg'),
  CalendarType: require('./calendartype.svg'),
  CompGreen: require('./CompGreen.svg'),
  CompRed: require('./CompRed.svg'),
  CompGrey: require('./CompGrey.svg'),
  FinalGreen: require('./FinalGreen.svg'),
  FinalRed: require('./FinalRed.svg'),
  FinalGrey: require('./FinalGrey.svg'),
  MapsJetty: require('./MapsJettyNew.png'),
  MapsJettySorong: require('./MapsJettySorongNew.png'),
  MapsJettyBackground: require('./maps-jetty-BG.png'),
  MapsJettyBackgroundSorong: require('./JettyBackground.png'),
  BackgroundLocation: require('./DashboardLocation.png'),
  LocationIcon: require('./location-icon.png'),
  VGeneralCargo: require('./GeneralL.png'),
  VGeneralCargoExtraSmall: require('./GeneralXS.svg'),
  VGeneralCargoSmall: require('./GeneralS.svg'),
  VGeneralCargoMedium: require('./GeneralM.svg'),
  VGeneralCargoLarge: require('./GeneralL.svg'),
  VGeneralCargoExtraLarge: require('./GeneralXL.svg'),
  VBarge: require('./BargeL.png'),
  VBargeSmall: require('./BargeS.png'),
  VBargeMedium: require('./BargeM.png'),
  VBargeLarge: require('./BargeL.png'),
  VLCT: require('./LCTL.png'),
  VLCTSmall: require('./LCTS.svg'),
  VLCTMedium: require('./LCTM.svg'),
  VLCTLarge: require('./LCTL.svg'),
  VTanker: require('./TankerL.png'),
  VTankerSmall: require('./TankerS.svg'),
  VTankerMedium: require('./TankerM.svg'),
  VTankerLarge: require('./TankerL.svg'),
  VTSV: require('./TSVL.png'),
  VTSVSmall: require('./TSVS.svg'),
  VTSVMedium: require('./TSVM.svg'),
  VTSVLarge: require('./TSVL.svg'),
  VRig: require('./Rig.png'),
  VRigMirror: require('./RigMirror.png'),
  AddCraneSmall: require('./AddCraneS.png'),
  AddCraneMedium: require('./AddCraneM.png'),
  AddCraneLarge: require('./AddCraneL.png'),
  AddBargeSmall: require('./AddBargeS.png'),
  AddBargeMedium: require('./AddBargeM.png'),
  AddBargeLarge: require('./AddBargeL.png'),
  VGearedSmall: require('./GearedS.png'),
  VGearedMedium: require('./GearedM.png'),
  VGearedLarge: require('./GearedL.png'),
  VGearlessSmall: require('./GearlessS.png'),
  VGearlessMedium: require('./GearlessM.png'),
  VGearlessLarge: require('./GearlessL.png'),
  Print: require('./print.svg'),
  Beyond: require('./Beyond.png'),
  Interport: require('./Interport.png'),
  Vale: require('./Vale.png'),
  JettyInfo: require('./JettyInfo.png'),
  Expired: require('./Expired.svg'),
  company: require('./company.svg'),
  time: require('./time.svg'),
  schedule: require('./Icon_schedule.svg'),
  ExportExcelIcon: require('./export-excel-icon.svg'),

  //cargo
  ImportIcon: require('./import.svg'),
  ExportIcon: require('./export.svg'),
  UploaderIcon: require('./uploader.svg'),
  XlsIcon: require('./xls.svg'),
  AddIcon: require('./add_icon.svg'),
  cargoIcon: require('./icon_cargo.svg'),
  dots: require('./dots.svg'),

  RedAnchor: require('./MapsJettyAnchor.png'),
  MapsJettyMorowali: require('./MapsJettyMorowali.png'),
  BerthMorowali: require('./BerthMorowali.svg'),
  BerthMorowaliMap: require('./BerthMorowaliMap.svg'),
  CompassMorowali: require('./CompassMorowali.svg'),
  MapsJettyBackgroundAdangBay: require('./MapsJettyBackgroundAdangBay.png'),
  MapsJettyBackgroundMorowali: require('./JettyBackgroundMorowali.png'),
  MapsJettyBackgroundMorowaliNoSand: require('./MapsJettyBackgroundMorowaliNoSand.png'),
  VBulkBarge: require('./BulkBargeL.png'),
  VBulkBargeSmall: require('./BulkBargeS.png'),
  VBulkBargeMedium: require('./BulkBargeM.png'),
  VBulkBargeLarge: require('./BulkBargeL.png'),
  MapsJettyWarning: require('./MapsJettyWarning.svg'),
  WarningModalIcon: require('./WarningModalIcon.svg'),

  // activity
  ExclamationIcon: require('./exclamation.svg'),
  AddTask: require('./AddTask.svg'),
  TallySheet: require('./TallySheet.svg'),
  TallySheetDisable: require('./TallySheetDisable.svg'),

  VesselForecast: require('./VesselForecast.svg'),

  // berthing management
  DefaultVesselBerthingManagement: require('./DefaultImageBerthingManagement.png'),
  AnchorIcon: require('./AnchorBerthingManagement.svg'),
  EmptyDataIcon: require('./empty-data-icon.svg'),
  EmptyVesselDataIcon: require('./empty-vessel-data-icon.svg'),
  BerthingManagementVessel: require('./berthing-management-vessel-icon.svg'),
  BerthingManagementTime: require('./berthing-management-time-icon.svg'),
  BerthingManagementTransferring: require('./berthing-management-transferring-icon.svg'),
  BerthingManagementDocument: require('./berthing-management-document-icon.svg'),
  BerthingManagementProcess: require('./berthing-management-process-icon.svg'),
  BerthingManagementBerthing: require('./berthing-management-berthing-icon.svg'),

  SmallCalendarIcon: require('./small-calendar-icon.svg'),
  DialogInfoIcon: require('./dialog-info-icon.svg'),
  VesselBouy: require('./VesselBouy.png'),
  NorthBouy: require('./NorthBouy.svg'),
  SouthBouy: require('./SouthBouy.svg'),
}
